/*
 *
 *  Mixin - Global Variables
 */

// export
export default {
  // computed
  computed: {
    // has mobile
    hasMobile() {
      // detect breakpoint
      const hasMobile = this.$vuetify.breakpoint.xs
      return hasMobile
    }
  }
}
